import type { PaywallCheckoutPreview } from "@/react/types";
import type { CheckoutPreviewEntryProps } from "../../../components/PreviewEntry";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { RawLines } from "../RawLines";
import { isOneInstallment } from "../variants/helpers";

const shouldShowTaxLine = (tax: number | undefined) => (tax || 0) > 0;

const showTax = (preview: PaywallCheckoutPreview) => ({
  value: preview?.future_payments?.formatted_tax,
  hide: !shouldShowTaxLine(preview?.future_payments?.tax),
});

const oneInstallmentsStrategies = {
  trial_then_value: (preview: PaywallCheckoutPreview) => ({
    value: preview.first_payment.formatted_tax,
    hide: !shouldShowTaxLine(preview?.first_payment?.tax),
  }),
  trial_then_upfront_then_value: showTax,
  upfront_then_trial_then_value: showTax,
  upfront_then_value: showTax,
  value: () => ({ hide: true }),
};

const buildOptions = (
  preview: PaywallCheckoutPreview,
): Partial<CheckoutPreviewEntryProps> => {
  if (isOneInstallment(preview)) {
    return oneInstallmentsStrategies[preview.preview_scenario](preview);
  }

  return { hide: !shouldShowTaxLine(preview?.future_payments?.tax) };
};

export const TaxLine = ({ preview }: Pick<ComponentLineProps, "preview">) => {
  const options = buildOptions(preview);
  return <RawLines.TaxLine preview={preview} options={options} />;
};
